import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { EventEmitterService } from "../../edtell-portal/services/event-emitter.service";
import { EmitterEvent } from "../../edtell-portal/enums/emitter-events.enum";
import { EdtellRouterInterceptor } from "../../edtell-portal/abstracts/edtell-router-interceptor.abstract";

@Injectable({ providedIn: "root" })
export class ProcessedJobStatusUpdateInterceptor extends EdtellRouterInterceptor {
  constructor(private eventService: EventEmitterService) {
    super();
  }

  onRequest(request: HttpRequest<unknown>): HttpRequest<unknown> {
    return request;
  }

  onResponse(response: HttpEvent<unknown>) {
    if (response instanceof HttpResponse) {
      if (response.headers.get("Processed") == "JobQueueUpdate") {
        this.eventService.emit(EmitterEvent.PROCESSED_REFRESH_JOB_BAR, null);
      }
    }
  }
}
